import { AnnouncementsTotalsPerCustomerComponent } from './announcements-totals-per-customer/announcements-totals-per-customer.component';
import { StatsAndReportsLookupResolveService } from './shared/services/stats-and-reports-lookup-resolve.service';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StatsAndReportsShellComponent } from '@admin/stats-and-reports/stats-and-reports-shell/stats-and-reports-shell.component';
import { StatsAndReportsListComponent } from '@admin/stats-and-reports/stats-and-reports-list/stats-and-reports-list.component';
import { SalesReportComponent } from '@admin/stats-and-reports/sales-report/sales-report.component';
import { SuspendedEmailsComponent } from './suspended-emails/suspended-emails.component';
import { CvDatabaseReportComponent } from './cv-database-report/cv-database-report.component';
import { MatchingAnnouncementsListComponent } from './matching-announcements-list/matching-announcements-list.component';
import { ViewAnnouncementMatchingListComponent } from './view-announcement-matching-list/view-announcement-matching-list.component';
import { JobseekerViewEditComponent } from '@admin/jobseekers/jobseeker-view-edit/jobseeker-view-edit.component';
import { IndexationReportComponent } from './indexation-report/indexation-report.component';
import { AuthGuard } from '../core/auth.guard';

const routes: Routes = [
  {
    path: 'stats-and-reports',
    component: StatsAndReportsShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: StatsAndReportsLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list',
      },
      {
        path: 'list',
        component: StatsAndReportsListComponent,
      },
      {
        path: 'announcements-totals-per-customer',
        component: AnnouncementsTotalsPerCustomerComponent,
      },
      {
        path: 'matching-announcements',
        component: MatchingAnnouncementsListComponent,
      },
      {
        path: 'announcement-matching-list/:listid',
        component: ViewAnnouncementMatchingListComponent,
        children: [
          {
            path: 'jobseeker/:id',
            component: JobseekerViewEditComponent,
          },
        ],
      },
      {
        path: 'sales-report',
        component: SalesReportComponent,
      },
      {
        path: 'cv-database-report',
        component: CvDatabaseReportComponent,
      },
      {
        path: 'messaging-report',
        component: SuspendedEmailsComponent,
      },
      {
        path: 'indexation-report',
        component: IndexationReportComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StatsAndReportsRoutingModule {}
